import type { YToolsQueryVariables, Y_Tools_Bool_Exp } from "gql/api";
import { Order_By } from "gql/api";

export function restoreYTools(arr: Array<string>): Y_Tools_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteYTools(arr: Array<string>): Y_Tools_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultYToolVars: YToolsQueryVariables = {
  order_by: [{ manufacturer: Order_By.Asc }],
  where: { deleted_at: { _is_null: true } }
};

export const kocYToolVars: YToolsQueryVariables = {
  order_by: [{ manufacturer: Order_By.Asc }],
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ],
    deleted_at: { _is_null: true }
  }
};

export const ecopetrolYToolVars: YToolsQueryVariables = {
  order_by: [{ manufacturer: Order_By.Asc }],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ],
    deleted_at: { _is_null: true }
  }
};
